import { useControlField, useField } from 'remix-validated-form'
import ComboAsync, { ComboboxAsyncProps } from 'app/components/ui/combo/combo-async'
import FormInputWrapper, { FormInputWrapperProps } from './FormInputWrapper'
import { OptionType } from 'types/OptionType'

type AsyncComboboxProps = FormInputWrapperProps<any> & ComboboxAsyncProps & { labelClassName: string }
/**
 * Combobox that receives options from api endpoint
 * @summary IMPORTANT: the input value will be the entire option object, so the validation schema that parses this input needs to refine the value like this:
 *
 * `comboVal: z.object({ value: z.string(), id: z.string(), name: z.string() }).transform((option) => option.value)`
 * @param {AsyncComboboxProps} props - queryURL needs to be the path to an api route i.e. /api/locations
 */
export default function FormComboAsync({
  name,
  queryURL,
  label,
  cols,
  wrapperClassName,
  labelClassName,
  inputClassName,
  newLineError,
  onChange,
  optionsMapper,
  showSearchInDropdown,
  ...props
}: Omit<AsyncComboboxProps, `value`> & { value: OptionType | undefined }) {
  const { error, defaultValue, setTouched } = useField(name)
  const [value, setValue] = useControlField<OptionType | undefined>(name)
  const changeHandler = (val) => {
    setTouched(val.id !== (defaultValue?.id ?? ``))
    setValue(val)
    onChange?.(val)
  }
  return (
    <>
      <FormInputWrapper
        {...{
          name,
          label,
          error,
          newLineError,
          cols,
          wrapperClassName,
          className: labelClassName,
          infoTooltip: props.infoTooltip,
        }}
      >
        <ComboAsync
          {...props}
          showSearchInDropdown={showSearchInDropdown}
          name={name}
          inputClassName={inputClassName}
          queryURL={queryURL}
          optionsMapper={optionsMapper}
          onChange={changeHandler}
          value={value}
        />
      </FormInputWrapper>
    </>
  )
}
